import moment from 'moment';

export default class Vision {
  static visionStatus = {
    active: 1,
    disabled: 0
  };

  static visionState = {
    negative: 0,
    neutral: 1,
    positive: 2
  };

  constructor({
    rowNum,
    id,
    userId,
    modulId,
    name,
    note,
    position,
    score,
    thresholdNegative,
    thresholdNeutral,
    thresholdPositive,
    state,
    status,
    statusName,
    updatedAt
  }) {
    this.rowNum = rowNum || null;
    this.id = id;
    this.userId = userId;
    this.modulId = modulId;
    this.name = name;
    this.note = note;
    this.position = position;
    this.score = score;
    this.thresholdNegative = thresholdNegative;
    this.thresholdNeutral = thresholdNeutral;
    this.thresholdPositive = thresholdPositive;
    this.state = state;
    this.status = status;
    this.statusName = statusName;
    this.updatedAt = updatedAt;
    this.expand();
  }

  expand() {
    let updatedAtFormatted = null;

    if (moment(this.updatedAt).isValid()) {
      updatedAtFormatted = moment(this.updatedAt).from();
    } else {
      updatedAtFormatted = null;
    }
    this.updatedAtFormatted = updatedAtFormatted;
  }

}
